import {call, put, delay, select} from 'redux-saga/effects'
import AuthActions, {AuthSelectors} from '../Redux/AuthRedux'
import {push} from 'connected-react-router'

import utils from '../Utils/utils'

export function* signIn(authApi, {email, password}) {
  try {
    let onBoardingFinished = yield select(AuthSelectors.getOnBoardingFinished)
    const response = yield call(authApi.signIn, email, password)
    if (response && response.access && response.userInfo) {
      yield put(AuthActions.signInSuccess(response.userInfo, response.access, response.refresh))
      if (response.userInfo?.payment_verification) utils.goLink(response.data?.payment_verification)
      yield delay(500)

      if (response.userInfo.role.id === 0) {
        if (onBoardingFinished || response.userInfo.payment_method) {
          yield put(push('/home/ad-library'))
        } else {
          yield put(push('/onboarding/plan'))
        }
      }
      if (response.userInfo.role.id === 1 || response.userInfo.role.id === 2) yield put(push('/admin/top-performing-products'))
    } else if (response) {
      yield put(AuthActions.signInFailure(response))
    } else {
      yield put(AuthActions.signInFailure('Server response error'))
    }
    if (response && response.status === 401) {
      console.log(401)
    }
  } catch (e) {
    yield put(AuthActions.signInFailure('Unknown error: ' + e))
  }
}

export function* confirmEmail(authApi, {hash, password}) {
  try {
    const response = yield call(authApi.confirmEmail, hash, password)
    if (response && response.access && response.userInfo) {
      yield put(AuthActions.signInSuccess(response.userInfo, response.access, response.refresh))
      yield delay(500)
      //yield put(push('/home/ad-library'));
      yield put(push('/registration-finished'))
    } else if (response) {
      yield put(AuthActions.signInFailure(response))
    } else {
      yield put(AuthActions.signInFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.signInFailure('Unknown error: ' + e))
  }
}

export function* createUser(authApi, {data}) {
  try {
    const response = yield call(authApi.createUser, data)
    if (response && response.ok) {
      yield put(AuthActions.signUpSuccess(response.data))
      yield delay(500)
      yield put(
        push({
          pathname: '/check-mailbox',
          state: response.data.email,
        }),
      )
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(AuthActions.signUpFailure(null))
        } else if (response.status === 500) {
          yield put(AuthActions.signUpFailure('Server response error'))
        } else {
          yield put(AuthActions.signUpFailure(response.data))
        }
      } else {
        yield put(AuthActions.signUpFailure('Server response error'))
      }
    }
    if (response && response.status === 401) {
      console.log(401)
    }
  } catch (e) {
    yield put(AuthActions.signUpFailure('Unknown error: ' + e))
  }
}

export function* socialAuth(authApi, {accessToken, socialType}) {
  try {
    const fn = socialType === 'fb' ? authApi.fbAuth : authApi.googleAuth
    const response = yield call(fn, accessToken)
    if (response && response.access && response.userInfo) {
      yield put(AuthActions.socialAuthSuccess(response.userInfo, response.access, response.refresh))
      yield delay(500)
      if (response.hash) {
        yield put(
          push({
            pathname: `/sign-up/confirm/${response.hash}`,
            state: true,
          }),
        )
      } else {
        yield put(push('/home/ad-library'))
      }
    } else if (response) {
      yield put(AuthActions.socialAuthFailure(response))
    } else {
      yield put(AuthActions.socialAuthFailure('Server response error'))
    }
    if (response && response.status === 401) {
      console.log(401)
    }
  } catch (e) {
    yield put(AuthActions.socialAuthFailure('Unknown error: ' + e))
  }
}

export function* logout(authApi) {
  try {
    //const response = yield call(authApi.logout);
    authApi.updateAccessToken(null)
    //yield delay(500)
    yield put(push('/login'))
  } catch (e) {
    console.log('error:', e)
  }
}

export function* restorePassword(authApi, {email}) {
  try {
    const response = yield call(authApi.restorePassword, email)
    if (response && response.ok) {
      yield put(AuthActions.restorePasswordSuccess())
      yield delay(500)
      yield put(AuthActions.signInReset())
      yield put(
        push({
          pathname: '/verify-mailbox',
          state: email,
        }),
      )
    } else if (response) {
      yield put(AuthActions.restorePasswordFailure(response.data.message ? response.data.message : response.data))
    } else {
      yield put(AuthActions.restorePasswordFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.restorePasswordFailure('Unknown error: ' + e))
  }
}

export function* restorePasswordWithVerify(authApi, {email}) {
  try {
    const response = yield call(authApi.restorePasswordWithVerify, email)
    if (response && response.ok) {
      yield put(AuthActions.restorePasswordWithVerifySuccess())
      yield delay(500)
      yield put(AuthActions.signInReset())
      yield put(
        push({
          pathname: '/verify-mailbox',
          state: email,
        }),
      )
    } else if (response) {
      yield put(AuthActions.restorePasswordWithVerifyFailure(response.data.message ? response.data.message : response.data))
    } else {
      yield put(AuthActions.restorePasswordWithVerifyFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.restorePasswordWithVerifyFailure('Unknown error: ' + e))
  }
}

export function* verifyMailRestorePassword(authApi, {data}) {
  try {
    //yield delay(500)
    /*yield put(AuthActions.verifyMailRestorePasswordSuccess())
    yield put(push({pathname: `/restore-password/78faacff806b6b28b84044f0f88df2849e0bcebae95dde07d97ebf16`}));*/
    //yield put(AuthActions.verifyMailRestorePasswordFailure({message: {detail: 'The code you entered was incorrect, please try again'}}))

    const response = yield call(authApi.verifyMailRestorePassword, data)

    if (response?.ok && response?.data?.valid) {
      yield put(AuthActions.verifyMailRestorePasswordSuccess())
      yield delay(500)
      yield put(AuthActions.signInReset())
      utils.goLink(response?.data?.reset_link)

      // yield put(
      //   // push({
      //   //   pathname: `/restore-password/${response.data?.hash || '78faacff806b6b28b84044f0f88df2849e0bcebae95dde07d97ebf16'}`,
      //   // }),
      //   push({pathname: response?.data?.reset_link}),
      // )
    } else if (response) {
      yield put(
        AuthActions.verifyMailRestorePasswordFailure(
          !response?.data?.valid ? {message: {detail: 'The code you entered was incorrect, please try again'}} : response.data,
        ),
      )
    } else {
      yield put(AuthActions.verifyMailRestorePasswordFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.verifyMailRestorePasswordFailure('Unknown error: ' + e))
  }
}

export function* resetPassword(authApi, {hash, password}) {
  try {
    const response = yield call(authApi.resetPassword, hash, password)
    if (response && response.ok) {
      yield put(AuthActions.resetPasswordSuccess(response.data))
      yield delay(500)
      //yield put(push('/login'))
      yield put(push('/registration-finished'))
    } else if (response) {
      yield put(AuthActions.resetPasswordFailure(response.data.message ? response.data.message : response.data))
    } else {
      yield put(AuthActions.resetPasswordFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.resetPasswordFailure('Unknown error: ' + e))
  }
}

export function* checkPasswordHash(authApi, {hash}) {
  try {
    const response = yield call(authApi.checkPasswordHash, hash)
    if (response && response.ok) {
      yield put(AuthActions.signInReset())
    } else if (response) {
      yield put(AuthActions.checkPasswordHashFailure(response.data))
    } else {
      yield put(AuthActions.checkPasswordHashFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.checkPasswordHashFailure('Unknown error: ' + e))
  }
}

export function* checkSocialHash(authApi, {hash}) {
  try {
    const response = yield call(authApi.checkSocialHash, hash)
    if (response && response.ok) {
      yield put(AuthActions.signInReset())
    } else if (response) {
      yield put(AuthActions.checkSocialHashFailure(response.data))
    } else {
      yield put(AuthActions.checkSocialHashFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.checkSocialHashFailure('Unknown error: ' + e))
  }
}

export function* checkEmailHash(authApi, {hash}) {
  try {
    const response = yield call(authApi.checkEmailHash, hash)
    if (response && response.ok) {
      yield put(AuthActions.checkEmailHashSuccess(response.data))
    } else if (response) {
      if (response.status === 410) {
        yield delay(500)
        yield put(
          push({
            pathname: '/expired',
            state: response.data.email,
          }),
        )
      } else if (response.status === 404) {
        yield delay(500)
        yield put(
          push({
            pathname: '/already-registered',
            state: response.data.email,
          }),
        )
      } else {
        yield put(AuthActions.checkEmailHashFailure(response.data))
      }
      yield put(AuthActions.signInReset())
    } else {
      yield put(AuthActions.checkEmailHashFailure('Server response error'))
      yield put(AuthActions.signInReset())
    }
  } catch (e) {
    yield put(AuthActions.checkEmailHashFailure('Unknown error: ' + e))
  }
}

export function* resendEmail(authApi, {email}) {
  try {
    const response = yield call(authApi.resendEmail, email)
    if (response && response.ok) {
      yield put(AuthActions.signInReset())
      yield delay(500)
      yield put(
        push({
          pathname: '/check-mailbox',
          state: email,
        }),
      )
      // yield put(push('/check-mailbox'))
    } else if (response) {
      yield put(AuthActions.resendEmailFailure(response.data))
    } else {
      yield put(AuthActions.resendEmailFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.resendEmailFailure('Unknown error: ' + e))
  }
}

export function* resendCode(authApi, {email}) {
  try {
    const response = yield call(authApi.resendCode, email)
    if (response && response.ok) {
      yield put(AuthActions.signInReset())
      yield delay(500)
      yield put(
        push({
          pathname: '/verify-mailbox',
          state: email,
        }),
      )
    } else if (response) {
      yield put(AuthActions.resendCodeFailure(response.data))
    } else {
      yield put(AuthActions.resendCodeFailure('Server response error'))
    }
  } catch (e) {
    yield put(AuthActions.resendCodeFailure('Unknown error: ' + e))
  }
}
